import { DecimalPipe } from '@angular/common';
import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { UserProfileService } from '@polaris-customerweb/sharedcomponents.user-profile';
import { firstValueFrom } from 'rxjs';
import { AreaDisplayService } from 'src/app/state/shared/services/area-display.service';

@Component({
    imports: [DecimalPipe],
    selector: 'rdx-area-display',
    standalone: true,
    styleUrls: ['./area-display.component.scss'],
    templateUrl: './area-display.component.html',
})
export class AreaDisplayComponent implements OnChanges, OnDestroy, OnInit {
    @Input() areaInMeters: number;

    isMetric = false;
    area: string;
    units: string;
    invalid = false;

    private isDestroyed = false;

    constructor(
        private areaDisplayService: AreaDisplayService,
        private profileService: UserProfileService
    ) {}

    async ngOnInit(): Promise<void> {
        this.isMetric = await firstValueFrom(
            this.profileService.getIsMetric$()
        );
        this.getMeasurementFormat();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.areaInMeters) {
            this.getMeasurementFormat();
        }
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    getMeasurementFormat(): void {
        const { isValid, value, units } =
            this.areaDisplayService.getMeasurementFormat(
                this.areaInMeters,
                this.isMetric
            );
        this.area = value;
        this.units = units;
        this.invalid = !isValid;
    }
}
